export default "__VITE_ASSET__DSuej3Kd__";